import {
    LocationType, AddressMainCategory,
    DeliveryServiceType,
    HandoverTime,
} from 'app/enums/label.enums'
import {
    FieldInCard,
    FormPart,
} from 'app/types/form.types'
import {
    Lane,
} from '../../lanes.types'

const positioningFields = ({
    deliveryServiceType,
    getAllowedValues,
}: {
    deliveryServiceType: DeliveryServiceType,
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
}): FormPart<keyof Lane> => {
    const isNotPickupFields: FieldInCard<keyof Lane>[] = [{
        id: 'positioning3',
        fields: [
            {
                name: 'fwdPos',
                componentName: 'FreightForwarderSelector',
                labelKey: 'LaneOpsInformationDto.fwdPos',
            },
            {
                name: 'fwdPosContacts',
                componentName: 'MultipleContactObjectSelector',
                labelKey: 'LaneOpsInformationDto.fwdPosContacts',
            },
            {
                name: 'fwdPosBackup',
                componentName: 'FreightForwarderSelector',
                labelKey: 'LaneOpsInformationDto.fwdPosBackup',
            },
            {
                name: 'fwdPosBackupContacts',
                componentName: 'MultipleContactObjectSelector',
                labelKey: 'LaneOpsInformationDto.fwdPosBackupContacts',
            },
        ],
    }]

    return {
        title: 'Positioning',
        className: 'positioning',
        fields: [
            {
                id: 'positioning1',
                fields: [
                    {
                        name: 'handoverEarliest',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(HandoverTime),
                        labelKey: 'LaneOpsInformationDto.handoverEarliest',
                    },
                    {
                        name: 'handoverLatest',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(HandoverTime),
                        labelKey: 'LaneOpsInformationDto.handoverLatest',
                    },
                    {
                        name: 'containerSelectionMax',
                        componentName: 'IntegerInput',
                        labelKey: 'LaneOpsInformationDto.containerSelectionMax',
                    },
                    {
                        name: 'orderInstructions',
                        componentName: 'LongText',
                        labelKey: 'LaneOpsInformationDto.orderInstructions',
                    },
                ],
            },
            {
                id: 'positioning2',
                fields: [
                    {
                        name: 'originSc',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                        filterLocationType: LocationType.ADDRESS,
                        labelKey: 'LaneOpsInformationDto.originSc',
                    },
                    {
                        name: 'originScContacts',
                        componentName: 'MultipleContactObjectSelector',
                        labelKey: 'LaneOpsInformationDto.originScContacts',
                    },
                    {
                        name: 'originScBackup',
                        componentName: 'LocationObjectSelector',
                        filterAddressMainCategory: AddressMainCategory.SERVICECENTER,
                        filterLocationType: LocationType.ADDRESS,
                        labelKey: 'LaneOpsInformationDto.originScBackup',
                    },
                    {
                        name: 'originScBackupContacts',
                        componentName: 'MultipleContactObjectSelector',
                        labelKey: 'LaneOpsInformationDto.originScBackupContacts',
                    },
                ],
            },
            ...deliveryServiceType === DeliveryServiceType.PICKUP ? [] : isNotPickupFields,
        ],
    }
}

export default positioningFields
